import type { JSX } from 'react';
import type { CuratorIgPostListData } from '@/services/slaydAPI/posts';
import styles from '../ApprovalPortalPage.module.css';

interface PostListProps {
  loadingList: boolean;
  posts: CuratorIgPostListData[];
  selectedPostId: number | undefined;
  onSelectPost: (postId: number) => void;
  getStatusClass: (isApproved: boolean | null) => string;
  getStatusLabel: (isApproved: boolean | null) => string;
  page: number;
  hasNext: boolean;
  hasPrevious: boolean;
  onNextPage: () => void;
  onPrevPage: () => void;
}

export const PostList = ({
  loadingList,
  posts,
  selectedPostId,
  onSelectPost,
  getStatusClass,
  getStatusLabel,
  page,
  hasNext,
  hasPrevious,
  onNextPage,
  onPrevPage,
}: PostListProps): JSX.Element => (
  <div className={styles.listPanel}>
    <div className={styles.listScroll}>
      {loadingList && (
        <div className={styles.loading}>
          <div className={styles.spinner} />
        </div>
      )}
      {!loadingList && posts.length === 0 && (
        <div className={styles.emptyState}>No posts found</div>
      )}
      {posts.map((post) => (
        <div
          key={post.id}
          className={`${styles.postRow} ${selectedPostId === post.id ? styles.postRowActive : ''}`}
          role="button"
          tabIndex={0}
          onClick={() => onSelectPost(post.id)}
          onKeyDown={(e) => e.key === 'Enter' && onSelectPost(post.id)}
        >
          <div className={styles.postRowThumb}>
            {post.mediaThumbnail ? (
              <img
                src={post.mediaThumbnail}
                alt=""
                className={styles.thumbImg}
              />
            ) : (
              <div className={styles.thumbPlaceholder}>
                {post.postType === 'INSTA_REEL' ? '🎬' : '📷'}
              </div>
            )}
            <div
              className={`${styles.thumbStatus} ${getStatusClass(post.isApproved)}`}
              title={getStatusLabel(post.isApproved)}
            />
          </div>
          <div className={styles.postRowBody}>
            <div className={styles.postRowCurator}>
              {post.curatorName || 'Unknown'}
            </div>
            <div className={styles.postRowCaption}>
              {post.caption ? post.caption : 'No caption'}
            </div>
            <div className={styles.postRowFooter}>
              <span className={styles.typePill}>
                {post.postType === 'INSTA_REEL' ? 'Reel' : 'Post'}
              </span>
              <span className={styles.productCount}>
                {post.productCount} products
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
    <div className={styles.pagination}>
      <button
        className={styles.pageBtn}
        disabled={!hasPrevious || loadingList}
        onClick={onPrevPage}
      >
        ← Prev
      </button>
      <span className={styles.pageNum}>Page {page}</span>
      <button
        className={styles.pageBtn}
        disabled={!hasNext || loadingList}
        onClick={onNextPage}
      >
        Next →
      </button>
    </div>
  </div>
);
